
import respUtility from '@/mixins/respUtility';
import { WISH_LIST } from '~/api/apolloQueries';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('listing');

export default {
  name: 'ListingProducts',
  mixins: [respUtility],
  props: {
    attrs: {
      type: Object,
      default() {
        return {};
      },
    },
    items: {
      type: Array,
      default() { return []; },
    },
    desktopFiltersVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      height: 'auto',
      skeletonHeight: 'auto',
    };
  },
  fetch() {
    this.fetchWishListIds();
  },
  fetchOnServer: false,
  mounted() {
    this.$taskManager.append(() => {
      this.skeletonHeight = this.$refs.productsList?.clientHeight;
    });
    window.addEventListener('pageshow', this.handlePageShow);
  },
  beforeDestroy() {
    window.removeEventListener('pageshow', this.handlePageShow);
  },
  watch: {
    getVisibleProductIds() {
      this.$nextTick(this.fetchWishListIds);
    },
  },
  methods: {
    async fetchWishListIds() {
      if (!this.getVisibleProductIds.length) {
        this.$store.commit('listing/setWishList', []);
        return;
      }
      // get product IDs for wish list
      const { wishlist } = await this.$graphql.default
        .request(WISH_LIST, { productIds: this.getVisibleProductIds }) || {};
      this.$store.commit('listing/setWishList', wishlist.productIds);
    },
    rerender(status) {
      if (!status) {
        this.height = 'auto';
        this.$taskManager.append(() => {
          this.skeletonHeight = this.$refs.productsList?.clientHeight;
        });
      } else {
        this.height = `${this.skeletonHeight > this.$refs.productsList.clientHeight
          ? this.skeletonHeight : this.$refs.productsList.clientHeight}px`;
      }
    },
    toggleDesktopFilters() {
      this.$emit('toggle-desktop-filters');
    },
    handlePageShow(event) {
      if (event.persisted) {
        this.fetchWishListIds();
      }
    },
  },
  computed: {
    ...mapState(['isSortingSticky']),
    getVisibleProductIds() {
      const result = [];
      this.items.forEach((item) => {
        if (item.dynamicAttribute) {
          if (item.dynamicAttribute.type === 'THUMBNAIL' || item.dynamicAttribute.type === 'SWATCH_THUMBNAIL') {
            const thumbnailIds = item.items.slice(0, 5).map((subItem) => Number(subItem.id));
            result.push(...thumbnailIds);
          } else {
            result.push(Number(item.id));
          }
        } else {
          result.push(Number(item.id));
        }
      });
      return result;
    },
    getWishList() {
      return this.$store.state.listing.wishList;
    },
    itemsCount() {
      return this.items.length;
    },
    filtersDataSort() {
      return this.attrs?.currentFiltersBlock || [];
    },
  },
  provide() {
    return {
      fetchWishListIds: this.fetchWishListIds,
    };
  },
};
